"use strict";var VNode = require("./VNode");
var inherit = require("raptor-util/inherit");

function VComment(value, ownerComponent) {
  this.bY_(-1 /* no children */, ownerComponent);
  this.bZ_ = value;
}

VComment.prototype = {
  c__: 8,

  br_: function (host) {
    var nodeValue = this.bZ_;
    return (host.ownerDocument || host).createComment(nodeValue);
  },

  bS_: function () {
    return new VComment(this.bZ_);
  }
};

inherit(VComment, VNode);

module.exports = VComment;